export const baseHiringGuidesURL = 'https://www.oysterhr.com/hire-employees/';

export const costCalculatorURL =
  'https://www.oysterhr.com/employee-cost-calculator/';

export const costCalculatorForCountryURL =
  'https://www.oysterhr.com/cost-of-hiring/';

// todo change keys to countryCodes
export const countriesLinks: { [key: string]: string } = {
  Argentina: 'argentina',
  Australia: 'australia',
  Austria: 'austria',
  Belarus: 'belarus',
  Belgium: 'belgium',
  'Bosnia and Herzegovina': 'bosnia-and-herzegovina',
  Brazil: 'brazil',
  Bulgaria: 'bulgaria',
  Canada: 'canada',
  Chile: 'chile',
  China: 'china',
  Colombia: 'colombia',
  'Costa Rica': 'costa-rica',
  Croatia: 'croatia',
  Denmark: 'denmark',
  Egypt: 'egypt',
  Estonia: 'estonia',
  Finland: 'finland',
  France: 'france',
  Germany: 'germany',
  Greece: 'greece',
  Hungary: 'hungary',
  India: 'india',
  Ireland: 'ireland',
  Israel: 'israel',
  Italy: 'italy',
  Japan: 'japan',
  Kenya: 'kenya',
  Latvia: 'latvia',
  Lebanon: 'lebanon',
  Lithuania: 'lithuania',
  Malaysia: 'malaysia',
  Mexico: 'mexico',
  Mongolia: 'mongolia',
  'New Zealand': 'new-zealand',
  Nigeria: 'nigeria',
  Norway: 'norway',
  Peru: 'peru',
  Poland: 'poland',
  Portugal: 'portugal',
  Romania: 'romania',
  Russia: 'russia',
  Serbia: 'serbia',
  Singapore: 'singapore',
  'South Africa': 'south-africa',
  'South Korea': 'south-korea',
  Spain: 'spain',
  Sweden: 'sweden',
  Switzerland: 'switzerland',
  Taiwan: 'taiwan',
  Czechia: 'the-czech-republic',
  Netherlands: 'netherlands',
  Philippines: 'the-philippines',
  'United Kingdom': 'united-kingdom',
  'United States of America': 'united-states',
  Turkey: 'turkey',
  Ukraine: 'ukraine',
  Uruguay: 'uruguay',
  Vietnam: 'vietnam',
};
